<template>
  <section class="section --center">
    <div class="section__content">
      <p v-if="content.header" class="text__accent">{{ content.header }}</p>
      <h2 :class="{ h2: content.header }">{{ content.title }}</h2>
      <p class="paragraph mt-16 mb-60">{{ content.description }}</p>
    </div>
    <div class="card__list">
      <ImageCard
        :button="content.button"
        :content="item"
        v-for="item in content.items"
        :key="content.flexKey"
      />
    </div>
  </section>
</template>

<script>
import ImageCard from '@/components/cards/ImageCard.vue'

export default {
  name: 'ActorsSection',
  components: { ImageCard },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>
